import chatBotService from "../../apiServices/common/chatBotService";
import { apiConfig } from "../../constants/apiConfig";
import { AiClient } from "../../constants/commonConstants";
import { IMessage, IUploadedFile } from "../../models/common/IChatBot";
import { setResponse } from "../../store/slices/common/chatBotSlice";
import {
  ISSECallbacks,
  streamBuduAgentPost,
  uploadChatFile as uploadChatFileApi,
  removeChatFile as removeChatFileApi,
  submitMessageFeedback as submitFeedbackApi,
} from "../../helper/sseClient";

export function aiChatAgent(
  data: IMessage,
  agentKey?: string,
  callbacks?: ISSECallbacks,
  signal?: AbortSignal,
) {
  return async function (dispatch: any) {
    if (apiConfig.aiClient === AiClient.BUDU) {
      if (!agentKey || !apiConfig.buduGPTBaseURL) {
        callbacks?.onError?.("Agent not configured. Please contact your administrator.");
        callbacks?.onDone?.();
        return;
      }

      return streamBuduAgentPost(
        agentKey,
        data,
        callbacks ?? { onChunk: () => {} },
        signal,
      );
    }

    try {
      const response = await chatBotService.aiChatAgentService(data);
      const text =
        response.success && !response.data.startsWith("Error")
          ? response.data
          : "Oops! Something unexpected happened. Please retry in a moment.";
      dispatch(setResponse(text));
    } finally {
      callbacks?.onDone?.();
    }
  };
}

export function submitFeedback(
  sessionId: number,
  messageIndex: number,
  rating: number,
  userQuestion?: string,
  chatResponse?: string,
  correctionText?: string,
) {
  return async function (): Promise<void> {
    await submitFeedbackApi(
      sessionId,
      messageIndex,
      rating,
      userQuestion,
      chatResponse,
      correctionText,
    );
  };
}

export function uploadFile(file: File, sessionId?: number | null, sourceType?: string) {
  return async function (): Promise<IUploadedFile> {
    return uploadChatFileApi(file, sessionId, sourceType);
  };
}

export function removeFile(uploadId: string) {
  return async function (): Promise<void> {
    await removeChatFileApi(uploadId);
  };
}